module.exports = {
  popUpOverlay: (theme) => {
  return {
    backgroundColor: "green",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: `${theme.main}70`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "1000"
  }
},

popUpFooter: (theme) => {
  return {
    backgroundColor: theme.colors.accent,
    width: '100%',
    maxHeight: '10%',
    height: '100%',
    padding: 0,
    margin: 0,
    borderRadius: "0px 0px 8px 8px"
  }
},

popUpBody: (theme) => {
  return {
    backgroundColor: theme.primary,
    borderRadius: "8px",
    maxWidth: "500px",
    width: "100%",
    maxHeight: "550px",
    height: "100%",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
    position: "relative",
  }
  },
  popUpContent: (theme) => {
    return {
      height: '90%'
    }
  }
}